import React, { useState, useEffect } from 'react';
import { Container, Typography, Grid } from '@mui/material';
import MailerLiteForm from './MailerLiteForm';
import Contact from './Contact';
import { styled, keyframes } from '@mui/system';

const Root = styled(Container)(({ theme }) => ({
  padding: theme.spacing(3, 1),
}));
const Newsletter = () => {

  return (
   <Root>
      <MailerLiteForm/>
      <Contact/>
       </Root>
  );
};

export default Newsletter;